import React from "react";

export const Button = ({ text,color,status,width}) => {
  return (
    <div className={`w-${width}`}>
      <button 
        className={`bg-black font-lato p-3 xs:text-[13px] md:text-[19px]  
          hover:bg-opacity-80 w-${width}   text-white`}
      >
        {text}
      </button>
    </div>
  );
};
